<template>
  <div class="table-view">
    <div class="card search" v-if="searchModel.length">
      <el-skeleton animated :loading="isSearchLoading">
        <el-form
          ref="searchForm"
          label-suffix=":"
          :label-position="labelPosition"
          :model="searchForm"
          @keyup.enter.native="handleSubmit"
        >
          <el-row>
            <el-col
              :xl="(item.layout && item.layout.xl) || 6"
              :lg="(item.layout && item.layout.lg) || 6"
              :md="(item.layout && item.layout.md) || 12"
              :sm="24"
              :xs="24"
              v-for="(item, index) in searchModel"
              :key="index"
            >
              <el-form-item :label="item.label" :prop="item.key">
                <el-input
                  v-if="item.type === 'input'"
                  :style="item.style || { width: '260px' }"
                  :placeholder="item.placeholder"
                  v-model="searchForm[item.key]"
                  clearable
                />
                <el-select
                  v-if="item.type === 'vagueSearchName'"
                  v-model="form[item.key]"
                  filterable
                  remote
                  clearable
                  reserve-keyword
                  placeholder="Customer name"
                  :remote-method="remoteName"
                >
                  <el-option
                    v-for="item in optionsName"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  clearable
                  filterable
                  @change="item.change && item.change($event)"
                  v-else-if="item.type === 'select'"
                  :style="item.style || { width: '260px' }"
                  :placeholder="item.placeholder"
                  v-model="searchForm[item.key]"
                >
                  <el-option
                    v-for="selectOption in item.selectList"
                    :value="selectOption.id"
                    :key="selectOption.id"
                    :label="selectOption.name"
                  >
                    {{ selectOption.name }}
                  </el-option>
                </el-select>
                <el-date-picker
                  type="daterange"
                  v-else-if="item.type === 'time'"
                  :style="item.style || { width: '260px' }"
                  value-format="yyyy-MM-dd"
                  v-model="searchForm[item.key]"
                />
              </el-form-item>
            </el-col>
            <!--  模糊查询槽位「work queue」-->
            <el-col :xl="6" :lg="6" :md="12" :sm="24" :xs="24">
              <slot name="vagueSearch"></slot>
            </el-col>
            <el-col :xl="6" :lg="8" :md="12" :sm="24" :xs="24">
              <el-form-item v-if="isSearchRow">
                <customize-button type="primary" @click="handleSubmit">
                  Search
                </customize-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="action" v-if="!isSearchRow">
          <customize-button class="clear-btn" @click="handleClickClearBtn">
            Clear
          </customize-button>
          <customize-button type="primary" @click="handleSubmit">
            Search
          </customize-button>
        </div>
      </el-skeleton>
    </div>

    <div class="card table" v-loading="isTableLoading">
      <div class="table-title">
        <div class="title">{{ tableCardTitle }}</div>
        <div class="action">
          <customize-button
            v-if="RightBtnOptions?.isHavePermission"
            :type="RightBtnOptions.loading ? 'disabled' : 'primary'"
            @click="$emit('changeTitleActionBtn')"
            :loading="RightBtnOptions.loading"
          >
            {{ RightBtnOptions.text }}
          </customize-button>
          <template v-else>
            <slot name="cardTitleRight"></slot>
          </template>
          <template>
            <slot name="btnArr"></slot>
          </template>
        </div>
      </div>
      <el-table
        :stripe="!rowClassName"
        :data="tableData"
        header-row-class-name="table-header"
        :row-class-name="row => (rowClassName ? rowClassName(row) : null)"
        @selection-change="handleSelectionChange"
      >
        <template></template>
        <template v-if="isMultiple">
          <el-table-column type="selection" width="55"></el-table-column>
        </template>
        <template v-for="item in tableModel">
          <el-table-column
            v-if="!item.slotName"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :min-width="item.minWidth"
            :fixed="item.fixed"
            :key="item.prop"
          >
            <template slot-scope="scope">
              <span v-html="scope.row[item.prop]"></span>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
            :key="item.prop"
          >
            <template v-if="item.slotName" slot-scope="scope">
              <slot :name="item.slotName" :tableRow="scope"></slot>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div class="pagination-wrapper" v-if="showPage">
        <span class="total">{{ pages.total }} Results</span>
        <el-pagination
          :page-size="pages.pageSize"
          :current-page.sync="pages.current"
          background
          layout="prev, pager, next"
          :total="pages.total"
          @current-change="handlePageChange"
        />
      </div>
      <div>
        <slot name="total"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tableView',
  data() {
    return {
      searchForm: {},
    }
  },
  watch: {
    searchModel: {
      deep: true,
      immediate: true,
      handler(newVal) {
        newVal.forEach(item => {
          this.$set(this.searchForm, item['key'], item.defaultValue || '')
        })
      },
    },
  },
  props: {
    labelPosition: {
      type: String,
      default: 'top',
    },
    // 要展示的数据
    searchModel: {
      type: Array,
      default: () => [],
    },
    // 查询表单部分是否显示，未显示为骨架屏
    isSearchLoading: {
      type: Boolean,
      default: false,
    },
    // search form 是否一排显示
    isSearchRow: {
      type: Boolean,
      default: false,
    },
    tableCardTitle: {
      type: String,
      default: '',
    },
    // table loading
    isTableLoading: {
      type: Boolean,
      default: false,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    current: {
      type: Number,
      default: 1,
    },
    RightBtnOptions: {
      type: Object,
      default: () => {},
    },
    pages: {
      type: Object,
      default: () => {},
    },
    tableModel: {
      required: true,
    },
    tableData: {
      required: true,
    },
    // 是否为多选table
    isMultiple: {
      type: Boolean,
      default: false,
    },
    // 是否显示pagination
    showPage: {
      type: Boolean,
      default: true,
    },
    rowClassName: {
      type: Function,
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('searchChange', this.getSearchData())
    },
    handlePageChange(current) {
      this.$emit('pageChange', {
        ...this.getSearchData(),
        current,
      })
    },
    getSearchForm() {
      return { ...this.searchForm }
    },
    getSearchData() {
      let values = { ...this.searchForm }
      const obj = {}
      const { pageSize, current } = this.pages
      // 处理第一次无法拿到 searchData，就从 props 里边拿默认值
      if (!Object.keys(values).length) {
        this.searchModel.forEach(item => {
          obj[item.decorator[0]] = item.defineValue
        })
        delete obj.time
      }
      if (Object.prototype.hasOwnProperty.call(values, 'time')) {
        values = { ...values, startTime: '', endTime: '' }
        if (Array.isArray(values.time)) {
          // 处理 time 转换为 startTime 和 endTime
          if (values.time && values.time.length) {
            values.startTime = values['time'][0]
            values.endTime = values['time'][1]
          }
        }
        delete values.time
      }
      values = { ...obj, ...values, size: pageSize, current }
      return values
    },
    handleClickClearBtn() {
      this.$refs.searchForm.resetFields()
      this.$emit('clickClearBtn')
    },
    handleSelectionChange(selectList) {
      this.$emit('selectionChange', selectList)
    },
  },
}
</script>

<style scoped lang="scss">
.table-view {
  .card {
    background: #ffffff;
    border-radius: 8px;
    padding: 24px 24px 24px;
  }

  .search {
    margin-bottom: 24px;
    :deep(.el-form-item__label) {
      line-height: 4px;
    }
    :deep(.el-form-item) {
      margin-bottom: 16px;
    }
    :deep(.el-input__inner) {
      height: 32px;
    }
    .action {
      text-align: right;
    }
  }

  .clear-btn {
    margin-right: 16px;
  }

  .table {
    .table-title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 50px;

      .title {
        font-size: 16px;
        color: #3a3f63;
        line-height: 24px;
        font-weight: 700;
      }
    }
    :deep(.table-header) {
      th {
        background-color: #f5f5fa;
        height: 56px;
        font-size: 14px;
        color: #000;
        line-height: 20px;
      }
    }
    :deep(.table-row) {
      border-left: 1px solid #000;
      td {
        height: 56px;
        font-size: 14px;
        color: #3a3f63;
        line-height: 20px;
      }
    }
    :deep(.warning-row) {
      color: #e41e20;
    }

    :deep(.success-row) {
      color: #54afe1;
    }

    .pagination-wrapper {
      margin-top: 16px;
      display: flex;
      justify-content: space-between;

      .total {
        font-size: 16px;
        color: #5a607f;
        line-height: 24px;
      }

      :deep(.is-background .active) {
        background-image: linear-gradient(46deg, #fe7301 0%, #e41e20 100%);
        box-shadow: 0 4px 16px 0 rgba(158, 2, 32, 0.1);
        border-radius: 4px;
      }

      :deep(.btn-prev),
      :deep(.btn-next),
      :deep(.el-pager li) {
        background: #ffffff;
        box-shadow: 0 4px 8px 0 rgba(179, 192, 231, 0.32);
        border-radius: 4px;
      }
    }
  }
}
</style>
